module.exports = __webpack_public_path__ + "img/brand_2.d3c63057.png";